//React
import React from 'react';

import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myPhotoAction from '../action/myPhotoAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
//Dialog
import DialogMyPhotoMain from './DialogMyPhotoMain';
import DialogMyPhotoSub from './DialogMyPhotoSub';
import DialogMyPhotoSort from './DialogMyPhotoSort';
//Add
import DialogConfirm from './DialogConfirm';
//Part
import PartRequestBalloon from './PartRequestBalloon';
import PartMainPhotoSample from './PartMainPhotoSample';
import PartSubPhotoSample from './PartSubPhotoSample';
import PartInputInfoBalloon from './PartInputInfoBalloon';
//img
import NoimgMen from '../img/user/noimg_men.jpg';
import NoimgWomen from '../img/user/noimg_women.jpg';
//Icon
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photoDelId: null,
      photoMainRequestId: null,
      photoMainRequestRestriction: 0,
      photoMainRequestStop: false,
      photoMainDelDialog: false,
      photoMainRestrictionDialog: false,
      mainPhotoDialog:false,
      photoSubDialog:false,
      photoSortDialog:false,
      editId: null,
      editAnchor: null,
      editMenu: [],
  	}
  }


  _renderImgMain() {
    let img = null;
    let editMenu = [];

    if (this.props.my.proof.photo === 1) {
      editMenu.push('mainDelNgProof');
    }
    else {
      editMenu.push('mainDel');
    }


		if (this.props.my.photo.main.uriCrop) {
      let src;
      if (this.props.my.photo.mainRestriction === 1) {
        src = this.props.my.photo.main.uriCropBlur;
        editMenu.push('mainRestrictionOff');
      }
      else {
        src = this.props.my.photo.main.uriCrop;
        editMenu.push('mainRestrictionOn');
      }

			img = (
				<div style={{position:'relative'}}>
					<img
						src={ src }
            style={{width:'100%', height:'auto'}}
            alt=''
					/>

          {
            (this.props.my.photo.mainRestriction === 1) && (
              <div
                style={{
                  position:'absolute',
                  top:0,
                  left:0,
                  height:"100%",
                  width: "100%",
                  display: 'flex',
                  justifyContent:'center',
                  alignItems:'center',
                  backgroundColor:'rgba(0, 0, 0, 0.5)',
                  cursor:'pointer',
                }}
                onClick={ (event) => this.props.popoverOpen(event.currentTarget, (<div><img src={this.props.my.photo.main.uriCrop} style={{ width:'120px', height:'auto'}} alt='' /></div>)) }
              >
                <div>
    							<div style={{fontSize:'1.2em', color:'white'}}>公開制限</div>
    							<div style={{color:'white', fontSize:'0.9em'}}>
                    <span className='i-b'>メイン写真を掲載中の方にだけ</span>
                    <span className='i-b'>このメイン写真は公開されます</span>
                  </div>
                </div>
              </div>
            )
          }
          <Fab
            size='small'
            style={{position:'absolute',top:'3px',right:'3px'}}
            color="primary"
            onClick={ (event) => this.setState({editId:'main', editAnchor:event.currentTarget, editMenu: ['preview', 'mainReplace', 'mainDel', ((this.props.my.photo.mainRestriction === 1) ? 'mainRestrictionOff': 'mainRestrictionOn')]}) }
          >
            <MoreVertSharpIcon />
          </Fab>

				</div>
			)
		}
		else {
      let uri;

			if (this.props.my.profile.userdata_sex === 'men') {
				uri = NoimgMen;
			}
			else {
				uri = NoimgWomen;
			}

			img = (
        <div style={{position:'relative'}}>
  				<img
  					src={ uri }
            style={{width:'100%', height:'auto'}}
            alt=''
  			  />
          {
            (this.props.my.request.photo > 0) ? (
              <div>
                <PartRequestBalloon
                  color={'red'}
                  arrow={'top'}
                >
                  <div>
                    メイン写真を申請中
                  </div>
                  <div>12時間以内に申請結果をメールでお知らせします</div>
                </PartRequestBalloon>
              </div>
            ) : (
              <div
                style={{
                  position:'absolute',
                  top:0,
                  left:0,
                  height:"100%",
                  width: "100%",
                  display: 'flex',
                  justifyContent:'center',
                  alignItems:'center',
                  backgroundColor:'rgba(0, 0, 0, 0.5)'
                }}
              >
                <div style={{margin:'10px'}}>
                  <div>
                    <div
                      style={{fontSize:'1.4em', fontWeight:'900', color:'#FFF', margin:'5px'}}
                    >
                      メイン写真が未掲載の為<br/>マッチングしにくい状態です
                    </div>
                    <div style={{color:'#FFF', margin:'5px'}}>
                      メイン写真はプロフや検索に表示される<br/>重要な写真です。<br/>
                      掲載を強くオススメいたします。
                    </div>
                  </div>
                  <div style={{margin:'5px'}}>
                    <Fab
                      variant="extended"
                      color="primary"
                      onClick={ () => this.setState({mainPhotoDialog: true}) }
                      style={{margin:'5px'}}
                    >
                      <AddAPhotoIcon />&nbsp;
                      メイン写真を掲載する
                    </Fab>
                  </div>
                </div>
              </div>
            )
          }

			  </div>
			)
		}
    return (
      <div id='photo_main_outer'>
        { img }
      </div>
    )
	}

  _renderImgList = (value, index, array) => {
    let Img;
    let editMenu = [];
		Img = (
			<div style={{position:'relative'}}>
				<img
					src={ (value.secret === 1) ? value.uriCropBlur: value.uriCrop }
					style={{ width:'100%', height:'auto'}}
          alt=''
				/>
        {
          (value.secret === 1) && (
            <div
              style={{
                position:'absolute',
                top:0,
                left:0,
                height:"100%",
                width: "100%",
                display: 'flex',
                justifyContent:'center',
                alignItems:'center',
                backgroundColor:'rgba(0, 0, 0, 0.5)'
                ,cursor:'pointer',
              }}
              onClick={ (event) => this.props.popoverOpen(event.currentTarget, (<div><div>あなたがお気に入りに登録した方<br/>だけに公開する写真です</div><img src={value.uriCrop} style={{ width:'120px', height:'auto'}} alt='' /></div>)) }
            >
  						<div style={{color:'#FFFFFF'}}>シークレット</div>
  					</div>
          )
        }
        {
          (value.mainRequest === 1) && (
            <div style={{position:'absolute', width:'100%', bottom:'0px',backgroundColor:'rgba(0, 0, 0, 0.8)'}}>
  						<div style={{color:'#FFFFFF'}} align='center'>メイン写真<br/>申請中</div>
  					</div>
          )

        }
			</div>
		)

    if (value.mainRequest === 1) {
      editMenu.push('mainRequestStop');
    }
    else {
      editMenu.push('del');
      editMenu.push('mainRequest');

      if (value.secret === 1) {
        editMenu.push('secretOff');
      }
      else {
        editMenu.push('secretOn');
      }
    }
    if (array.length >= 2) {
      editMenu.push('sort');
    }
    editMenu.push('preview');

    return (
      <div
        key={index}
        className='box_outer'
      >
        <div
          className='box_inner round12'
        >
          <div style={{position:'relative'}}>
            { Img }
            <Fab
              size='small'
              style={{position:'absolute',top:'3px',right:'3px'}}
              color="primary"
              onClick={ (event) => this.setState({editId:value.id, editAnchor:event.currentTarget, editMenu:editMenu}) }
            >
              <MoreVertSharpIcon />
            </Fab>
          </div>

        </div>
      </div>
    )
	}

  _editMenuClose() {
    this.setState({
      editId:null,
      editAnchor:null,
      editMenu:[]
    })
  }

  render() {

    let photoCount = this.props.my.photo.sub.length + ((this.props.my.photo.main.uri) ? 1 : 0);

    return (
      <div>

        <div style={{textAlign:'center'}}>
          {
            this._renderImgMain({
              uri: this.props.my.photo.main.uriCrop,
              restriction: this.props.my.photo.mainRestriction,
              sex: this.props.my.profile.userdata_sex,
            })
          }
        </div>

        <div align='center' style={{margin:'1px'}}>
          <div id={'photo_sub_block'}>
          {
            (this.props.my.photo.sub.length > 0) ? (
  						this.props.my.photo.sub.map((value, index, array) =>
  							this._renderImgList(value, index, array)
  						)
            ): (
              <div style={{marginTop:'10px',marginBottom:'10px'}}>
                <h3>サブ写真も掲載しましょう</h3>
                <PartSubPhotoSample />
              </div>
            )
					}
          </div>
        </div>
        <div style={{textAlign:'center', fontSize:'1.2em'}}>
          { photoCount } / {this.props.config.profilePhotoLimit}
        </div>
        {
          ((this.props.config.profilePhotoLimit - photoCount) > 0) && (
            <div align='center'>
              <Fab
                variant="extended"
                color="primary"
                onClick={ () => this.setState({photoSubDialog: true}) }
              >
                <AddAPhotoIcon />&nbsp;
                サブ写真を掲載する
              </Fab>

            </div>
          )
        }
        <DialogMyPhotoSub
          open={ this.state.photoSubDialog }
          close={ () => this.setState({photoSubDialog: false}) }
        />

        <Menu
          anchorEl={this.state.editAnchor}
          keepMounted
          open={(this.state.editId)? true: false}
          onClick={ () => this._editMenuClose() }
        >

          {
            (this.state.editMenu.includes('mainRequest')) && (
              <MenuItem
                onClick={ () => this.setState({photoMainRequestId: this.state.editId}) }
              >
                メイン写真に申請する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('mainRequestStop')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoMainRequestStop() }
              >
                メイン写真の申請を停止する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('mainRestrictionOn')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoMainRestriction(1) }
              >
                <div style={{width:'100px'}}>
                  公開制限を設定する
                  <div style={{fontSize:'0.8em',color:'#666'}}>
                    メイン写真を掲載している方<br/>にだけ公開されます。<br/>
                    未掲載の方にはボカシの写真が<br/>表示されます
                  </div>
                </div>
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('mainRestrictionOff')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoMainRestriction(0) }
              >
                <div>
                  公開制限を解除する
                  <div style={{fontSize:'0.8em',color:'#666',maxWidth:'240px'}}>
                    メイン写真はすべての方に<br/>公開されます
                  </div>
                </div>
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('secretOn')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoSecret(this.state.editId, 1) }
              >
                <div>
                    シークレットに設定する
                    <div style={{fontSize:'0.9em',color:'#666',maxWidth:'240px'}}>
                      あなたがお気に入りに登録した方<br/>だけに公開する設定です
                    </div>
                </div>

              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('secretOff')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoSecret(this.state.editId, 0) }
              >
                シークレットを解除する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('sort')) && (
              <MenuItem
                onClick={ () => this.setState({photoSortDialog: true}) }
              >
                掲載する順番を編集する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('preview')) && (
              <MenuItem
                onClick={ () => this.props.history.push('/my/preview/') }
              >
                プレビューで表示を確認する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('mainReplace')) && (
              <MenuItem
                onClick={ () => this.setState({mainPhotoDialog: true}) }
              >
                メイン写真を変更する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('mainDel')) && (
              <MenuItem
                onClick={ () => this.setState({photoMainDelDialog: true}) }
              >
                メイン写真を削除する
              </MenuItem>
            )
          }
          {
            (this.state.editMenu.includes('del')) && (
              <MenuItem
                onClick={ () => this.props.myPhotoDel(this.state.editId) }
              >
                写真を削除する
              </MenuItem>
            )
          }
        </Menu>

        <Dialog
          open={ (this.state.photoMainRequestId) ? true : false  }
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              メイン写真に申請しますか？
            </div>

            <IconButton
              onClick={ () => this.setState({photoMainRequestId: null}) }
            >
              <CloseIcon/>
            </IconButton>
          </div>
          {
            (this.props.my.proof.photo === 1) ? (
              <>
                <div style={{padding:'10px'}}>
                  <div style={{margin:'5px'}}>
                    <div>写真証明が提出済の為、メイン写真を申請できませんでした。</div>
                    <div>写真証明を削除してから、メイン写真を申請してください。</div>
                  </div>
                  <div style={{margin:'5px'}}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size='small'
                      onClick={ () => this.props.history.push('/my/proof/') }
                    >
                      写真証明の削除はコチラから
                    </Button>
                  </div>
                </div>
              </>
            ): (
              <>
                <h3 align='center'>メイン写真はお顔の雰囲気が<br/>伝わる写真だけ掲載できます</h3>

                <div style={{padding:'10px'}}>
                  <PartMainPhotoSample />
                </div>

                <div align='center'>
                  <Select
                    value={this.state.photoMainRequestRestriction}
                    onChange={ (e) => this.setState({photoMainRequestRestriction: e.target.value}) }
                  >
                    <MenuItem value={ 0 }>公開制限しない</MenuItem>
                    <MenuItem value={ 1 }>公開制限する</MenuItem>

                  </Select>
                </div>

                <div align='center' >
                  <PartInputInfoBalloon>
                    {
                      (this.state.photoMainRequestRestriction) ? (
                        <div>メイン写真を掲載中の会員にだけ<br />公開する設定です</div>
                      ): (
                        <div>すべての会員に公開する設定です</div>
                      )
                    }
                  </PartInputInfoBalloon>
                </div>

                <div align='center' style={{padding:'10px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{fontSize:'1.1em'}}
                    onClick={ () => {
                      this.props.myPhotoMainRequest(this.state.photoMainRequestId, this.state.photoMainRequestRestriction);
                      this.setState({photoMainRequestId: null});
                    } }
                  >
                    メイン写真に申請する
                  </Button>
                </div>
              </>
            )
          }

        </Dialog>


        <DialogConfirm
          open={ this.state.photoMainDelDialog }
          title={'メイン写真を削除'}
          content={
            (this.props.my.proof.photo === 1) ? (
              <>
                <div style={{margin:'5px'}}>
                  <div>写真証明が提出済の為、メイン写真を削除できませんでした。</div>
                  <div>写真証明を削除してから、メイン写真を削除してください。</div>
                </div>
                <div style={{margin:'5px'}}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size='small'
                    onClick={ () => this.props.history.push('/my/proof/') }
                  >
                    写真証明の削除はコチラから
                  </Button>
                </div>
              </>
            ): (
              <>
                <div align='center' style={{padding:'10px'}}>
                  <div align='center' style={{padding:'5px'}}>

                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize:'1em'}}
                      onClick={ () => {
                        this.props.myPhotoMainDel( () => {} );
                        this.setState({photoMainDelDialog: false});
                      } }
                    >
                        メイン写真を削除してサブ写真にする
                    </Button>
                  </div>
                  <div align='center' style={{padding:'5px'}}>

                    <Button
                      variant="outlined"
                      color="primary"
                      style={{fontSize:'1em'}}
                      onClick={ () => {
                        this.props.myPhotoMainDel( () => {
                          this.props.myPhotoDel(this.props.my.photo.main.id);
                        });
                        this.setState({photoMainDelDialog: false});
                      } }
                    >
                      メイン写真を削除する
                    </Button>
                  </div>
                </div>
              </>
            )
          }
          close={ () => this.setState({photoMainDelDialog: false}) }
        />

        <DialogMyPhotoMain
          open={ this.state.mainPhotoDialog }
          close={ () => this.setState({mainPhotoDialog: false}) }
        />
        <DialogMyPhotoSort
          open={ this.state.photoSortDialog }
          close={ () => this.setState({photoSortDialog: false}) }
        />
      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    config: state.config,
		ui: state.ui,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myPhotoAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
